var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrame4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 401,
    viewBox: "0 0 600 401",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3001_8441)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M180.981 19C159.115 19 141.39 36.742 141.39 58.6278V300.737H220.571V58.6278C220.571 36.742 202.846 19 180.981 19Z",
    fill: "#2563EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.43 308.911L248.81 368.93H351.183L341.492 308.911H257.43Z",
    fill: "#94A3B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.763 377.582H213.257V381.908H386.763V377.582Z",
    fill: "#94A3B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.81 368.929L213.257 377.58H386.75L351.184 368.929H248.81Z",
    fill: "#CBD5E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.562 53.2046H483.438C492.581 53.2046 500 60.6496 500 69.8248V278.01H100V69.8248C100 60.6496 107.419 53.2046 116.562 53.2046Z",
    fill: "#475569"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 278.009H500V299.925C500 309.061 492.607 316.48 483.504 316.48H116.496C107.393 316.48 100 309.061 100 299.925V278.009Z",
    fill: "#CBD5E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.255 66.1826H114.76V264.092H485.255V66.1826Z",
    fill: "#DBEAFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.41 65.8589H115.52V264.725H188.41V65.8589Z",
    fill: "#F8FAFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.31 78.408H209.777C205.8 78.408 202.576 81.6319 202.576 85.6089C202.576 89.5859 205.8 92.8098 209.777 92.8098H465.31C469.287 92.8098 472.511 89.5859 472.511 85.6089C472.511 81.6319 469.287 78.408 465.31 78.408Z",
    fill: "#F8FAFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.36 96.5322H209.777C205.8 96.5322 202.576 99.7562 202.576 103.733C202.576 107.71 205.8 110.934 209.777 110.934H258.36C262.337 110.934 265.561 107.71 265.561 103.733C265.561 99.7562 262.337 96.5322 258.36 96.5322Z",
    fill: "#F8FAFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.543 96.5322H279.96C275.983 96.5322 272.759 99.7562 272.759 103.733C272.759 107.71 275.983 110.934 279.96 110.934H328.543C332.52 110.934 335.744 107.71 335.744 103.733C335.744 99.7562 332.52 96.5322 328.543 96.5322Z",
    fill: "#F8FAFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.035 114.656H218.052C209.505 114.656 202.576 121.585 202.576 130.133V232.397C202.576 240.945 209.505 247.874 218.052 247.874H457.035C465.582 247.874 472.511 240.945 472.511 232.397V130.133C472.511 121.585 465.582 114.656 457.035 114.656Z",
    fill: "#F8FAFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.321 81.3259H135.401C132.96 81.3259 130.981 83.3045 130.981 85.7452C130.981 88.1859 132.96 90.1644 135.401 90.1644H166.321C168.762 90.1644 170.74 88.1859 170.74 85.7452C170.74 83.3045 168.762 81.3259 166.321 81.3259Z",
    fill: "#BFDBFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.321 101.213H135.401C132.96 101.213 130.981 103.192 130.981 105.632C130.981 108.073 132.96 110.052 135.401 110.052H166.321C168.762 110.052 170.74 108.073 170.74 105.632C170.74 103.192 168.762 101.213 166.321 101.213Z",
    fill: "#BFDBFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.321 121.1H135.401C132.96 121.1 130.981 123.078 130.981 125.519C130.981 127.96 132.96 129.938 135.401 129.938H166.321C168.762 129.938 170.74 127.96 170.74 125.519C170.74 123.078 168.762 121.1 166.321 121.1Z",
    fill: "#BFDBFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.321 160.872H135.401C132.96 160.872 130.981 162.851 130.981 165.292C130.981 167.732 132.96 169.711 135.401 169.711H166.321C168.762 169.711 170.74 167.732 170.74 165.292C170.74 162.851 168.762 160.872 166.321 160.872Z",
    fill: "#BFDBFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.321 140.987H135.401C132.96 140.987 130.981 142.965 130.981 145.406C130.981 147.847 132.96 149.825 135.401 149.825H166.321C168.762 149.825 170.74 147.847 170.74 145.406C170.74 142.965 168.762 140.987 166.321 140.987Z",
    fill: "#BFDBFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.321 180.759H135.401C132.96 180.759 130.981 182.738 130.981 185.178C130.981 187.619 132.96 189.598 135.401 189.598H166.321C168.762 189.598 170.74 187.619 170.74 185.178C170.74 182.738 168.762 180.759 166.321 180.759Z",
    fill: "#BFDBFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.804 295.721C307.804 300.046 304.303 303.559 299.993 303.559C295.683 303.559 292.183 300.046 292.183 295.721C292.183 291.395 295.683 287.882 299.993 287.882C304.303 287.882 307.804 291.395 307.804 295.721Z",
    fill: "#64748B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M290.574 66.177L210.914 264.073H255.008L333.95 66.177H290.574Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M361.369 66.177L287.012 264.073H304.723L380.386 66.177H361.369Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.407 149.485V57.701C214.407 38.8265 200.986 23.0292 183 19.0035H379.172C379.285 19.0035 379.397 19.0026 379.51 19.0017C379.735 19 379.959 18.9983 380.183 19.0035C402.605 19.5303 420.616 37.5493 420.616 59.686V327.595H255.851C232.961 327.595 214.407 309.381 214.407 286.913V149.485H214.407Z",
    fill: "#3B82F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.531 95.4062L322.683 102.546L329.731 103.692L324.63 109.251L325.834 117.101L319.531 113.393L313.229 117.101L314.433 109.251L309.331 103.692L316.38 102.546L319.531 95.4062Z",
    fill: "#FFFA2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.281 102.082L352.696 109.221L360.333 110.367L354.809 115.926L356.11 123.776L349.281 120.069L342.452 123.776L343.757 115.926L338.233 110.367L345.867 109.221L349.281 102.082Z",
    fill: "#FFFA2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.383 122.107L374.797 128.698L382.433 129.755L376.907 134.886L378.211 142.132L371.383 138.714L364.555 142.132L365.86 134.886L360.333 129.755L367.969 128.698L371.383 122.107Z",
    fill: "#FFFA2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.432 150.477L386.11 157.619L394.335 158.764L388.385 164.322L389.787 172.171L382.432 168.464L375.078 172.171L376.483 164.322L370.534 158.764L378.755 157.619L382.432 150.477Z",
    fill: "#FFFA2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.034 178.848L382.186 185.988L389.234 187.133L384.133 192.692L385.337 200.542L379.034 196.838L372.731 200.542L373.936 192.692L368.834 187.133L375.883 185.988L379.034 178.848Z",
    fill: "#FFFA2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.182 203.878L364.597 211.022L372.234 212.167L366.706 217.726L368.011 225.572L361.182 221.869L354.353 225.572L355.658 217.726L350.134 212.167L357.768 211.022L361.182 203.878Z",
    fill: "#FFFA2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.984 217.229L337.399 224.372L345.032 225.518L339.508 231.077L340.813 238.923L333.984 235.219L327.155 238.923L328.456 231.077L322.932 225.518L330.57 224.372L333.984 217.229Z",
    fill: "#FFFA2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.231 217.229L307.908 224.372L316.133 225.518L310.184 231.077L311.586 238.923L304.231 235.219L296.877 238.923L298.282 231.077L292.333 225.518L300.554 224.372L304.231 217.229Z",
    fill: "#FFFA2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.883 203.878L281.298 211.022L288.932 212.167L283.408 217.726L284.713 225.572L277.883 221.869L271.054 225.572L272.359 217.726L266.832 212.167L274.469 211.022L277.883 203.878Z",
    fill: "#FFFA2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.881 178.848L264.295 185.988L271.931 187.133L266.405 192.692L267.709 200.542L260.881 196.838L254.053 200.542L255.358 192.692L249.831 187.133L257.467 185.988L260.881 178.848Z",
    fill: "#FFFA2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.783 150.477L259.198 157.619L266.832 158.764L261.308 164.322L262.612 172.171L255.783 168.464L248.954 172.171L250.256 164.322L244.731 158.764L252.369 157.619L255.783 150.477Z",
    fill: "#FFFA2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.682 122.107L271.096 128.698L278.732 129.755L273.205 134.886L274.51 142.132L267.682 138.714L260.854 142.132L262.159 134.886L256.632 129.755L264.268 128.698L267.682 122.107Z",
    fill: "#FFFA2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.784 102.082L293.198 109.221L300.832 110.367L295.308 115.926L296.613 123.776L289.784 120.069L282.955 123.776L284.256 115.926L278.732 110.367L286.369 109.221L289.784 102.082Z",
    fill: "#FFFA2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.531 95.4062L322.683 102.546L329.731 103.692L324.63 109.251L325.834 117.101L319.531 113.393L313.229 117.101L314.433 109.251L309.331 103.692L316.38 102.546L319.531 95.4062Z",
    fill: "#FFFA2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.427 157.412H334.153C334.175 157.057 334.004 156.843 334.004 156.655V147.034C334.004 144.294 331.915 142.134 329.115 142.134H312.013C309.212 142.134 306.76 144.294 306.76 147.034V156.655C306.76 156.843 306.956 157.057 306.974 157.412H304.701C301.791 157.412 299.132 159.515 299.132 162.361V192.07C299.132 194.916 301.791 197.204 304.701 197.204H336.427C339.337 197.204 341.633 194.913 341.633 192.07V162.361C341.633 159.515 339.337 157.412 336.427 157.412ZM324.498 184.414H316.63L317.36 176.942C316.027 175.979 315.155 174.462 315.155 172.718C315.155 169.797 317.578 167.442 320.564 167.442C323.55 167.442 325.973 169.819 325.973 172.739C325.973 174.487 325.104 175.976 323.768 176.939L324.498 184.414ZM330.699 157.412H310.433C310.298 157.057 310.033 156.701 310.033 156.41V146.927C310.033 146.014 310.97 145.335 311.904 145.335H329.227C330.161 145.335 330.735 146.014 330.735 146.927V156.41C330.735 156.701 330.833 157.057 330.699 157.412Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.86 327.545V327.595H419.055C445.596 327.595 467.112 309.825 467.112 287.904H295.272C295.272 309.159 278.252 326.511 256.86 327.545Z",
    fill: "#93C5FD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3001_8441"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 362.907,
    fill: "white",
    transform: "translate(100 19)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame4);
export default __webpack_public_path__ + "static/media/Frame-4.06f2b80999a8382a5b99f1c5bb1f5ecc.svg";
export { ForwardRef as ReactComponent };